/* eslint-disable no-useless-escape */
/* eslint-disable func-names */
/* eslint-disable no-bitwise */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import utils from "../utils";

// Калькулятор стоимости позапросной обработки.

const $ = window.jQuery;

const MAX_COUNT = 100000000;

function formatMoney(amount) {
    return (`${amount}`).length >= 5
        ? amount.toLocaleString("ru-RU", { maximumFractionDigits: 0 })
        : amount;
}

function compute_cost(count) {
    const { price } = window.DA.clean.rates[0];
    return price * count;
}

function CleanCalculator(calc_el, exchange_fn) {
    exchange_fn =
        exchange_fn ||
        function (val) {
            return val;
        };
    const cost_el = calc_el.querySelectorAll(".js-cost")[0];
    const count_el = calc_el.querySelectorAll(".js-count")[0];
    const $payment = $(calc_el)
        .closest(".js-calc-container")
        .find(".js-payment-amount");
    let count_changed_watchdog = null;

    calc_el.addEventListener("input", on_count_input);
    on_count_change(count_el.value);

    function add(s) {
        let total = 0;
        const strs = s.split("+");
        while (strs.length) {
            total += parseFloat(strs.shift()) || 0;
        }
        return total;
    }

    function round_payment_cost(cost) {
        if (cost < 10.0) return 10.0;
        return Math.ceil(cost / 10.0) * 10;
    }

    function on_count_input() {
        if (count_changed_watchdog) {
            clearTimeout(count_changed_watchdog);
            count_changed_watchdog = null;
        }
        count_changed_watchdog = setTimeout(() => {
            on_count_change(count_el.value);
            count_changed_watchdog = null;
        }, 200);
    }

    function on_count_change(count_val) {
        const count_str = count_val.trim()
            .replace(/[^0-9\+]/gi, "");
        let count = add(count_str);
        let cost = 0;
        if (!count || count < 0) {
            count = 0;
            count_el.value = count_str === "" ? "" : 0;
        } else {
            if (count > MAX_COUNT) {
                count = MAX_COUNT;
            }
            count_el.value = formatMoney(count);
        }

        cost = compute_cost(count);
        let cost_in_roubles = cost / 100.0;
        if (cost_in_roubles > 999999) {
            cost_in_roubles = Math.round(cost_in_roubles);
        }
        cost_el.innerHTML = formatMoney(exchange_fn(cost_in_roubles));

        // Update payment amount
        if ($payment.length) {
            const payment = $payment[0];
            payment.value = round_payment_cost(cost_in_roubles);
            payment.dispatchEvent(new Event("change"));
        }

        const records = calc_el.querySelector(".js-q-text");
        if (records) {
            records.innerHTML = utils.pluralize(count_el.value, ["запись", "записи", "записей"]);
        }
    }
}

export default { Calculator: CleanCalculator };
